export default "__VITE_PUBLIC_ASSET__90c2340d__"